export enum ValidationStatus {
    VALIDATED = "validated",
    UNVALIDATED = "unvalidated",
}
